import DashboardSuper from "../../../../../components/categories/siakad/laporan_adab/beranda/HomeSuper";
export default function Home() {
  
  return (
    <DashboardSuper />
  );
}
